import store from '../store'
let fbchannel = {
  SWVVFBBET: '1339817950218888',
  SWZYFB: '957895621990242',
  CWVVFBT: '896271524983664',
  CWVVFBY: '1686940725126758',
  CWVVFBAB: '304385262000864',
  CWVVFBWI: '304385262000864',
  CWVVFBABWI: '304385262000864',
  CWVVFBDLHUNT: '918309925973067',
  CWVVFBGAT: '581867573797335',
  SWVVFBGATHER: '751363942822513',
  CWVVFBL: '233280419847943',
  WVVFBABTL: '896271524983664',
  CWVVFBAPK: '3056823454449841',
  CWVVFBAPKA: '3056823454449841',
  CWVVFBAPKB: '3056823454449841',
  CWVVFBZQA: '850729089872713',
  CWFBZQB: '850729089872713',
  CWFBAPKA: '3056823454449841',
  CWFBT: '896271524983664',
  CWFBY: '1686940725126758',
  CWFBL: '233280419847943',
  CWFBBBTL: '1051162502632065',
  CWFBBBWT: '765282452202953'
}
window.casino_bangpay_fbchannelLog = fbchannel
let taboolaChannel = {
  SWZYTBLANDPAGE: 1606353,
  SWZYTBHOMEPAGE: 1596241,
  CWTLTBH5: 1623073,
  CWTLTBHOMEPAGE: 1623073,
  CWYYTBH5: 1623073,
  CWYYTBHOMEPAGE: 1623073,
  CWYYTBNH5: 1623073,
  CWYYTBH5: 1623073
}

let eventFacebook = function(eventName, data) {
  try {
    // let userInfo = store.getters['userInfo']
    // let fbid = getChannel(userInfo.channel)
    if (window.fbqId && fbq) {
      if (eventName == 'InitiateCheckout') {
        fbq('track', 'InitiateCheckout')
        let userInfo = store.getters['userInfo']
        if (userInfo && userInfo.cts) {
          let hh = (new Date().getTime() - Number(userInfo.cts)) / 1000 / 3600
          if (hh <= 24) {
            let uid = userInfo.userId + ''
            fbq('trackCustom', 'TodayAddtoCart', { custom_parameter: uid, value: 1, currency: 'USD' })
          }
        }
      } else if (eventName == 'Purchase') {
        console.log('先把这里的注释掉')
        // fbq('track', 'Purchase', { value: data.amount, currency: userInfo.country })
      }
    } else if (window.taboolafaId && window._tfa) {
      if (eventName == 'InitiateCheckout') {
        window._tfa.push({ notify: 'event', name: 'add_payment_info', id: window.taboolafaId })
        let userInfo = store.getters['userInfo']
        if (userInfo && userInfo.cts) {
          let hh = (new Date().getTime() - Number(userInfo.cts)) / 1000 / 3600
          if (hh <= 24) {
            window._tfa.push({ notify: 'event', name: 'today_payment_info', id: window.taboolafaId })
          }
        }
      }
    }
  } catch (error) {
    console.log(error)
  }
}
function userInfoAfter() {
  try {
    let userInfo = store.getters['userInfo']
    let fbid = getChannel(userInfo.channel)
    if (userInfo && userInfo.channel && fbid) {
      window.fbqId = fbid
      initFbq(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
    } else if (userInfo && userInfo.channel) {
      let tbid = getTaboolaChannel(userInfo.channel)
      if (tbid) {
        window.taboolafaId = tbid
        initTaboola(tbid)
      }
    }
  } catch (error) {
    console.log(error)
  }
}
function getChannel(channel) {
  if (channel) {
    channel = channel.toUpperCase()
  }
  let id = ''
  for (const key in fbchannel) {
    if (channel.indexOf(key) != -1) {
      id = fbchannel[key]
    }
  }
  return id
}
function initFbq(f, b, e, v, n, t, s) {
  if (f.fbq) return
  n = f.fbq = function() {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = !0
  n.version = '2.0'
  n.queue = []
  t = b.createElement(e)
  t.async = !0
  t.src = v
  s = b.getElementsByTagName(e)[0]
  s.parentNode.insertBefore(t, s)
  if (f.fbqId && f.fbq) {
    console.log('fbq加载完成')
    f.fbq('init', f.fbqId)
  }
}

function getTaboolaChannel(channel) {
  if (channel) {
    channel = channel.toUpperCase()
  }
  let id = ''
  for (const key in taboolaChannel) {
    if (channel.indexOf(key) != -1) {
      id = taboolaChannel[key]
    }
  }
  return id
}

function initTaboola(_tbId) {
  window._tfa = window._tfa || []
  window._tfa.push({ notify: 'event', name: 'page_view', id: _tbId })
  !(function(t, f, a, x) {
    if (!document.getElementById(x)) {
      t.async = 1
      t.src = a
      t.id = x
      f.parentNode.insertBefore(t, f)
    }
  })(document.createElement('script'), document.getElementsByTagName('script')[0], '//cdn.taboola.com/libtrc/unip/' + _tbId + '/tfa.js', 'tb_tfa_script')
}

export { eventFacebook, userInfoAfter }



// WEBPACK FOOTER //
// ./src/utils/facebook.js